export function isValidEmail(input) {
    const atIndex = input.indexOf('@');
    if (atIndex <= 0 || atIndex === input.length - 1) {
        return false;
    }
    const dotIndex = input.indexOf('.', atIndex + 1);
    return dotIndex > atIndex + 1 && dotIndex < input.length - 1;
}
//# sourceMappingURL=is-valid-email.js.map